import type { HelpFile } from '../../types/help'
import { PartiesTestIds } from '../../../testids/PartiesTestIds'

export const partiesHelp: HelpFile = {
  docPage: '/docs/identity/parties',
  texts: {
    [PartiesTestIds.partiesList]:
      'Übersicht aller Parteien — die realen Akteure (Personen, Organisationen, KI-Agenten), an denen Identitäten und Konten hängen.',
    [PartiesTestIds.partyRow]: null,
  },
}
